import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: 0,
  currentPage: 1,

}

const loginInstructionSlice = createSlice({
  name: 'loginInstruction',
  initialState: {
    status: true, 
    currentPage: 1
  },
  reducers: {
    setStatus: (state, action) => {
      state.status = action.payload;
    },
     setCurrentPageCount: (state, action) => {
      state.currentPage = action.payload; // <-- Reducer to update currentPage
    },
  },
});

export const { setStatus, setCurrentPageCount } = loginInstructionSlice.actions;

export default loginInstructionSlice.reducer;